<template>
  <div class="card text-center">
    <div class="card-body">
      <div v-if="!isDelivery">
        <h3>Who’s Picking</h3>
        <h3>Up this order?</h3>
      </div>
      <div v-else>
        <h3>We'll Ask For</h3>
      </div>
      <div>{{ firstName }} {{ lastName }}</div>
      <div>{{ email }}</div>
      <div>{{ phone | toMasked(phoneMask) }} {{ extension }}</div>
    </div>
  </div>
</template>

<script>
import { phoneMask } from '@/masks'

export default {
  props: {
    isDelivery: {
      type: Boolean,
    },
    firstName: {
      type: String,
    },
    lastName: {
      type: String,
    },
    email: {
      type: String,
    },
    phone: {
      type: String,
    },
    extension: {
      type: String,
    },
  },
  computed: {
    phoneMask() {
      return phoneMask
    },
  },
}
</script>

<style lang="scss" scoped>
h3 {
  line-height: 1;
  text-transform: uppercase;
}
</style>
